module.exports = __webpack_public_path__ + "img/SC-PROOF-5999.aa02f6f2.png";